/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPaginatedListOfPayoutSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeCreatePayoutCommand, type CreatePayoutCommand, type PaginatedListOfPayoutSummary, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { ExportRequestBuilderNavigationMetadata, ExportRequestBuilderRequestsMetadata, type ExportRequestBuilder } from './exportEscaped/index.js';
// @ts-ignore
import { PayoutsItemRequestBuilderNavigationMetadata, PayoutsItemRequestBuilderRequestsMetadata, type PayoutsItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /payouts
 */
export interface PayoutsRequestBuilder extends BaseRequestBuilder<PayoutsRequestBuilder> {
    /**
     * The export property
     */
    get exportEscaped(): ExportRequestBuilder;
    /**
     * Gets an item from the ApiSdk.payouts.item collection
     * @param id Unique identifier of the item
     * @returns {PayoutsItemRequestBuilder}
     */
     byId(id: Guid) : PayoutsItemRequestBuilder;
    /**
     * GetPayouts
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedListOfPayoutSummary>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<PayoutsRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedListOfPayoutSummary | undefined>;
    /**
     * CreatePayout
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: CreatePayoutCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * GetPayouts
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<PayoutsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * CreatePayout
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreatePayoutCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * GetPayouts
 */
export interface PayoutsRequestBuilderGetQueryParameters {
    criteria?: string;
    pageNumber?: number;
    pageSize?: number;
    sortExpression?: string;
}
/**
 * Uri template for the request builder.
 */
export const PayoutsRequestBuilderUriTemplate = "{+baseurl}/payouts{?Criteria*,PageNumber*,PageSize*,SortExpression*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const PayoutsRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "criteria": "Criteria",
    "pageNumber": "PageNumber",
    "pageSize": "PageSize",
    "sortExpression": "SortExpression",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const PayoutsRequestBuilderNavigationMetadata: Record<Exclude<keyof PayoutsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: PayoutsItemRequestBuilderRequestsMetadata,
        navigationMetadata: PayoutsItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["id"],
    },
    exportEscaped: {
        requestsMetadata: ExportRequestBuilderRequestsMetadata,
        navigationMetadata: ExportRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const PayoutsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: PayoutsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedListOfPayoutSummaryFromDiscriminatorValue,
        queryParametersMapper: PayoutsRequestBuilderGetQueryParametersMapper,
    },
    post: {
        uriTemplate: PayoutsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreatePayoutCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
